"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.handleAuthenticationUpdated = void 0;var _url = require("./utils/url");
var _const = require("./const");
var _authenticationTokens = require("./models/authenticationTokens");


const handleAuthenticationUpdated = (authentication) => {
  if (!authentication || !authentication.accessToken) {
    return;
  }

  let url = (0, _url.removeQueryStringParam)(window.location.href, _const.QS_AUTH_CODE);
  url = (0, _url.removeQueryStringParam)(url, _const.QS_STATE);
  if (url !== window.location.href) {
    window.history.pushState(null, null, url);
  }

  _authenticationTokens.AuthenticationTokens.set(authentication);
};exports.handleAuthenticationUpdated = handleAuthenticationUpdated;